import React, { Component } from 'react';
import ipCamC100 from '../../media/ipcam-c100.png';
import ipCamC600 from '../../media/ipcam-c600.png';


class CCAMPage extends Component {
    render() {
        return (
            <div className="container-flex">
				<div className="ccam-app">
					<div className="ccam-app__half">
						<div className="ccam-img">
							<img className="img-responsive" src={ipCamC100} alt="IPCAM C100" />
						</div>
					</div>
					<div className="ccam-app__half">
						<div className="ccam-img">
							<img className="img-responsive" src={ipCamC600} alt="IPCAM C600" />
						</div>
					</div>
				</div>
				<div className="ccam-description">
    				<p>
					Google rules have changed which effect adding your C100, C600 cams under device manager. 
					You will need to download AMIKO CCAM application for adding your camera. 
					After adding your devices to AMIKO CCAM application then 
					You can choose whether you still use AMIKO CCAM or wants to use AMIKO HOME application in the future.
					Once your cameras are added with AMIKO CCAM, your devices will be available via AMIKO HOME app as well.
					</p>
  				</div>
				<a className="btn btn-amiko btn-ccam-app" href="/app-ccam-release.apk">Download</a> 
            </div>
        );
     }
}

export default CCAMPage;


// WEBPACK FOOTER //
// ./src/components/page/CCAMPage.js